<template>
    <div class="c-time-line">
        <div
            class="c-time-line__item"
            v-for="(item, index) in data"
            :key="`timeline_${index}`"
            :class="makeClass(item, index)"
            @click="handleStepClick(item, index)"
        >
            <div class="c-time-line__item-tail">
                <i></i>
            </div>
            <div class="c-time-line__item-head">
                <div class="c-time-line__item-head__inner"></div>
            </div>
            <div class="c-time-line__item-content">
                <slot name="content" :data="item">
                    {{ item.content }}
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        data: {
            type: Array,
            default() {
                return [];
            },
        },
        current: {
            // 当前步骤,从 0 开始计数
            type: Number,
            default: 0,
        },
        // status: {
        //     type: String, // 骤的状态，可选值为wait、process、finish、error，不设置时自动判断
        //     default: 'process',
        // },
    },
    data() {
        return {
            currentStep: this.current,
            statusList: ['wait', 'process', 'finish', 'error'],
        };
    },
    computed: {},
    methods: {
        makeClass(item, index) {
            let currentStep = this.currentStep;
            let st = '';
            let pre = 'c-time-line__item-';
            let status = item.status;
            if (this.statusList.indexOf(status) !== -1) {
                st = `${pre}${status}`;
            } else if (index < currentStep) {
                st = `${pre}finish`;
            } else if (index === currentStep) {
                st = `${pre}process`;
            } else {
                st = `${pre}wait`;
            }
            return st;
        },
        handleStepClick(step, index) {
            // this.currentStep = index;
            this.$emit('step-click', { data: step, index });
        },
    },
    created() {},
    mounted() {},
    watch: {
        current(val) {
            this.currentStep = val;
        },
    },
};
</script>

<style lang="scss" scoped>
$finish: #1ee7e7;
$process: #1890ff;
$wait: #969799;
$error: #f56c6c;
.c-time-line {
    &__item {
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 50%;
        margin-bottom: 10px;
        cursor: pointer;
        &-tail {
            width: 100%;
            position: absolute;
            left: 0px;

            top: 10px;

            > i {
                width: 100%;
                height: 1px;
                position: relative;
                display: inline-block;
                vertical-align: top;
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background-color: #647886;
                }
            }
        }
        &-head {
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            background: rgba($process, 0.4);
            top: 10px;
            margin-left: 10%;
            transform: translateY(-50%);
            &__inner {
                position: relative;
                display: inline-block;
                vertical-align: top;
                width: 10px;
                height: 10px;
                background: rgba($process, 1);
                border-radius: 50%;
            }
        }
        &-content {
        }
        &-process {
            .c-time-line__item {
                &-head {
                    width: 30px;
                    height: 30px;
                    background: rgba($process, 0.4);
                    &__inner {
                        background: rgba($process, 1);
                    }
                }
            }
        }
        &-finish {
            .c-time-line__item {
                &-head {
                    background: rgba($finish, 0.4);
                    &__inner {
                        background: rgba($finish, 1);
                    }
                }
            }
        }
        &-wait {
            .c-time-line__item {
                &-head {
                    background: rgba($wait, 0.4);
                    &__inner {
                        background: rgba($wait, 1);
                    }
                }
            }
        }
        &-error {
            .c-time-line__item {
                &-head {
                    background: rgba($error, 0.4);
                    &__inner {
                        background: rgba($error, 1);
                    }
                }
            }
        }
    }
}
</style>
